

/**
 * displays special DM branded background
 * 
 */

import React from 'react';
import bgImg from './bg.jpg';
import bgImgLogo from './bg-logo.jpg';
import bgImgDesktop from './bg-desktop.jpg';
import bgImgDesktopLogo from './bg-logo-desktop.jpg';


class BrandBackground extends React.Component {

  render() {

    let src = "url(" + bgImg + ")";
    
    if( this.props.withLogoBg ){
      src = "url(" + bgImgLogo + ")";
    }

    let bgContainerStyles = {
      "position" : "absolute",
      "top" : "0",
      "bottom" : "0",
      "left" : "0",
      "right" : "0",
      "overflow" : "hidden",
      "backgroundImage" : src,
      "backgroundRepeat" : "no-repeat",
      "backgroundPosition" : "top center",
      "backgroundSize" : "cover"
    }

    let bgDesktop     = Object.assign( {}, bgContainerStyles );
    let bgMobile      = Object.assign( {}, bgContainerStyles );

    bgDesktop.backgroundImage = "url(" + bgImgDesktop + ")";
    bgMobile.backgroundImage = "url(" + bgImg + ")";
    if( this.props.withLogoBg ){
      bgDesktop.backgroundImage = "url(" + bgImgDesktopLogo + ")";
      bgMobile.backgroundImage = "url(" + bgImgLogo + ")";
    }


    return (
      <div>
        <div className="app-bacground desktop" style={bgDesktop}>
        </div>
        <div className="app-bacground mobile" style={bgMobile}>
        </div>
      </div>
    );
  }

}

export default BrandBackground; 